import React from 'react';
import ProjectDetail from './ProjectDetail';
import { projectMeta } from './data';
import { toCdn } from '../utils/cdn';
import ProgressiveImg from '../components/ProgressiveImg';
import Figure from '../components/Figure';

export default function Figma() {
  const meta = projectMeta.figma;
  return (
    <ProjectDetail title={meta.title} date={meta.date} role={meta.role} url={meta.url}>
      {/* Custom per-project content goes here */}

      <p>Figma to Swift is a Figma plugin that generates SwiftUI from your design tokens and exports them as a Swift package. Once included in Xcode, developers will have access to design tokens directly through Xcode's editor and code complete.</p>

      <div className="media-gallery">

        <Figure caption="Figma">
          <div className="video-mask">
            <video
              src={toCdn('/images/projects/figma/figma.mp4')}
              poster={toCdn('/images/projects/figma/figma_poster.webp')}
              alt="Figma"
              className="gallery-item"
              loading="lazy"
              controls
            />
          </div>
        </Figure>

        <Figure caption="Figma">
          <ProgressiveImg
            src={toCdn('/images/projects/figma/figma_2.webp')}
            alt="Figma"
            className="gallery-item"
          />
        </Figure>

      </div>
    </ProjectDetail>
  );
}